import * as hyejoo from '../hyejoo';
import * as models from '../models';

// GetLineItems maps the site network's catalog line items by id, for
// labeling order and quote lines. Unlimited: callers look up any line.
const lineItems = hyejoo.Getters('/v2/line-items', resp => models.LineItemsHyejooResponse.fromJSON(resp).results);

export function GetLineItems(params: { data: string }): Promise<Map<string, models.LineItem>> {
    return lineItems.getAll({ max: -1, ...params });
}
